import React from 'react';
import { observer } from 'mobx-react-lite';
import { Table, ButtonMenu, Icon, Checkbox } from '@ann/web-components';
import { formatLastUpdated } from '../../../../../utils/dateUtils';

const UnifiedTable = observer(({
    folders,
    documents,
    selectionStore,
    onShare,
    onDuplicate,
    onAssignAgent,
    onRenameFolder,
    onRenameDocument,
    onFolderInfo,
    onMove,
    onDelete
}) => {
    const getUnifiedTableData = () => {
        const foldersData = folders.map((folder) => {
            const folderData = folder;
            return {
                type: 'folder',
                itemData: folder,
                select: (
                    <Checkbox
                        checked={folder.isSelected}
                        onChange={() => {
                            folder.setSelected(!folder.isSelected);
                            selectionStore.toggleFolderSelection(folder.folder_uuid || folder.id);
                        }}
                        size="medium"
                    />
                ),
                name: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Icon name="folder" />
                        <span>{folder.name || folder.title}</span>
                    </div>
                ),
                owner: folder.owner_full_name || folder.owner || '-',
                lastModified: formatLastUpdated(folder.updated_at || folder.lastUpdated).label,
                sharedWith: '-',
                documentsInside: '-',
                element: (
                    <ButtonMenu
                        customIcon="dotsMenu"
                        disableEffects={true}
                        menuPosition="bottom"
                        onChange={() => { }}
                        size="small"
                        type="secondary"
                        width="180px"
                    >
                        <ButtonMenu.Menu icon={true}>
                            <ButtonMenu.Item
                                label="Rename"
                                value="Rename"
                                icon="edit"
                                onClick={() => onRenameFolder && onRenameFolder(folderData)}
                            >
                                Rename
                            </ButtonMenu.Item>
                            {/* <ButtonMenu.Item
                                label="Share"
                                value="Share"
                                icon="personAdd"
                                onClick={() => onShare(folderData, 'folder')}
                            >
                                Share
                            </ButtonMenu.Item>
                            <ButtonMenu.Item
                                label="Duplicate"
                                value="Duplicate"
                                icon="controlPointDuplicate"
                                onClick={() => onDuplicate(folderData, 'folder')}
                            >
                                Duplicate
                            </ButtonMenu.Item>
                            <ButtonMenu.Item 
                                label="Move" 
                                value="Move" 
                                icon="driveFileMove"
                                onClick={() => onMove && onMove(folderData.folder_uuid || folderData.id, 'folder')}
                            >
                                Move
                            </ButtonMenu.Item> */}
                            <ButtonMenu.Item
                                label="Folder Information"
                                value="Folder Information"
                                icon="info"
                                onClick={() => onFolderInfo && onFolderInfo(folderData)}
                            >
                                Folder Information
                            </ButtonMenu.Item>
                        </ButtonMenu.Menu>
                    </ButtonMenu>
                )
            };
        });

        const documentsData = documents.map((doc) => {
            const docData = doc; 
            return {
                type: 'document',
                itemData: doc,
                select: (
                    <Checkbox
                        checked={doc.isSelected}
                        onChange={() => {
                            doc.setSelected(!doc.isSelected);
                            selectionStore.toggleDocumentSelection(doc.document_uuid || doc.id);
                        }}
                        size="medium"
                    />
                ),
                name: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Icon name="description" />
                        <span>{doc.name || doc.title}</span>
                    </div>
                ),
                owner: doc.owner_full_name || doc.owner || '-',
                lastModified: formatLastUpdated(doc.created_at || doc.date).label,
                sharedWith: '-',
                documentsInside: '-',
                element: (
                    <ButtonMenu
                        customIcon="dotsMenu"
                        disableEffects={true}
                        menuPosition="bottom"
                        onChange={() => { }}
                        size="small"
                        type="secondary"
                        width="180px"
                    >
                        <ButtonMenu.Menu icon={true}>
                            <ButtonMenu.Item
                                label="Rename"
                                value="Rename"
                                icon="edit"
                                onClick={() => onRenameDocument && onRenameDocument(docData)}
                            >
                                Rename
                            </ButtonMenu.Item>
                            {/* <ButtonMenu.Item
                                label="Share"
                                value="Share"
                                icon="personAdd"
                                onClick={() => onShare(docData, 'document')}
                            >
                                Share
                            </ButtonMenu.Item>
                            <ButtonMenu.Item
                                label="Duplicate"
                                value="Duplicate"
                                icon="controlPointDuplicate"
                                onClick={() => onDuplicate(docData, 'document')}
                            >
                                Duplicate
                            </ButtonMenu.Item> */}
                            {onAssignAgent && (
                                <ButtonMenu.Item
                                    label="Assign Agent"
                                    value="AssignAgent"
                                    icon="bolt"
                                    onClick={() => onAssignAgent(docData)}
                                >
                                    Assign Agent
                                </ButtonMenu.Item>
                            )}
                            {/* <ButtonMenu.Item 
                                label="Move" 
                                value="Move" 
                                icon="driveFileMove"
                                onClick={() => onMove && onMove(docData.document_uuid || docData.id, 'document')}
                            >
                                Move
                            </ButtonMenu.Item> */}
                            {onDelete && (
                                <ButtonMenu.Item 
                                    label="Delete" 
                                    value="Delete" 
                                    icon="delete"
                                    onClick={() => onDelete(docData)}
                                >
                                    Delete
                                </ButtonMenu.Item>
                            )}
                        </ButtonMenu.Menu>
                    </ButtonMenu>
                )
            };
        });

        return [...foldersData, ...documentsData];
    };

    const tableHeaders = [
        { label: '', value: 'select' },
        { label: 'Name', value: 'name' },
        { label: 'Owner', value: 'owner' },
        { label: 'Last Modified', value: 'lastModified' },
        { label: 'Shared With', value: 'sharedWith' },
        { label: 'Documents Inside', value: 'documentsInside' }
    ];

    return (
        <Table
            data={getUnifiedTableData()}
            headers={tableHeaders}
            mode="table"
            showActions
        />
    );
});

export default UnifiedTable;

